const mFeedAssetsContentModalInscripcionActiva = {
  mFeedAssetsContentModalInscripcionActiva: {
    buttonPrimary: 'ENTENDIDO',
    messageAlert: 'El curso no puede ser eliminado ya que uno o más alumnos tienen inscripciones activas.',
    title: 'ACCIÓN DESHABILITADA'
  }
}
export default mFeedAssetsContentModalInscripcionActiva
